import { useEffect, useState } from "react";

export function useMessengerBotUsernames() {
  const [telegramBotUsername, setTelegramBotUsername] = useState("");
  const [maxBotUsername, setMaxBotUsername] = useState("");

  useEffect(() => {
    const baseUrl = (process.env.REACT_APP_SERVER_URL || window.location.origin)
      .replace(/\/$/, "");

    fetch(`${baseUrl}/api/telegram/bot-info`)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data?.username) {
          setTelegramBotUsername(String(data.username).replace(/^@/, ""));
        }
      })
      .catch(() => {});

    fetch(`${baseUrl}/api/max/bot-info`)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data?.username) {
          setMaxBotUsername(String(data.username).replace(/^@/, ""));
        }
      })
      .catch(() => {});
  }, []);

  return { telegramBotUsername, maxBotUsername };
}
